import Lookup from 'src/componentes/select2';

const NivelAcaoLookup = (props) => {
  return (
    <Lookup
      showSearch={false}
      labelKey="descricao"
      valueKey="id"
      url="/NivelAcaoLookup"
      clearable={true}
      {...props}
    />
  );
};

export default NivelAcaoLookup;
